define.alias("shared/components/shared/credentials/basic-display-status/upgrade", "settings/components/shared/credentials/basic-display-status/upgrade");